import { Box } from '@primer/react';
import { useEffect, useState } from 'react';
import { financeHelperApi } from '../../../api/financeHelperApi';
import { IStepData } from '../../../components/steps/Steps';
import { useCommonSelectedHook } from '../../../hooks/useCommonSelectedHook';
import { ITinhBaoPhiInsertModel, ITinhBaoPhiItemRequest } from '../../../models/request/bao-phi/ITinhBaoPhiItemRequest';
import { ISendEmailBaoPhiRequest } from '../../../models/request/hoc-sinh/ISendEmailBaoPhiRequest';
import { IHocSinh } from '../../../models/response/crm-hocsinh/IHocsinh';
import { IKhoanNopChungTuVm } from '../../../models/response/finance/IKhoanNop';
import { ITinhBaoPhiKhoanResponse, ITinhBaoPhiVm } from '../../../models/response/finance/ITinhBaoPhi';
import BaoPhiSteps from './BaoPhiSteps';
import DanhSachKhoanNop from './DanhSachKhoanNop';
import GuiBaoPhi from './GuiBaoPhi';
import HinhThucMienGiam from './HinhThucMienGiam';
import HinhThucNopPhi from './HinhThucNopPhi';
import KetQuaBaoPhi from './KetQuaBaoPhi';
import ThankForm from './ThankForm';
const steps: IStepData[] = [
    { id: 1, name: "Lựa chọn dịch vụ, ưu đãi", is_active: true },
    // { id: 2, name: "Lựa chọn ưu đãi, miễn giảm", is_active: false },
    { id: 2, name: "Lựa chọn khoản báo phí", is_active: false },
    { id: 3, name: "Xem kết quả", is_active: false },
    { id: 4, name: "Gửi báo phí", is_active: false },
    // { id: 5, name: "Done", is_active: false },
]
interface BaoPhiProps {
    hocSinh: IHocSinh;
    onCancel(): void;
    tinhBaoPhiEditing?: ITinhBaoPhiVm;
}

const BaoPhiCreateLayout: React.FC<BaoPhiProps> = ({ hocSinh, onCancel, tinhBaoPhiEditing }) => {
    const { dm_coso_id, nam_hoc } = useCommonSelectedHook();
    const [khoanNopChungTus, setKhoanNopChungTus] = useState<IKhoanNopChungTuVm[]>([]);
    const [tinhBaoPhiKhoanResponses, setTinhBaoPhiKhoanResponses] = useState<ITinhBaoPhiKhoanResponse>();
    const [sf_tinhbaophi_id, set_sf_tinhbaophi_id] = useState<number>(tinhBaoPhiEditing?.id ?? 0)
    const [hinhThucNopBomIds, setHinhThucNopBomIds] = useState<number[]>([]);
    const [isTinhMienGiam, setIsTinhMienGiam] = useState<boolean>(false)
    const [currentStepId, setCurrentStepId] = useState<number>(1)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    useEffect(() => {
        if (tinhBaoPhiEditing) {
            handleReloadDataBaoPhi();
        }
    }, [tinhBaoPhiEditing])
    useEffect(() => {
        if (tinhBaoPhiKhoanResponses) {
            const mappedData: IKhoanNopChungTuVm[] =
                tinhBaoPhiKhoanResponses.sf_tinhbaophi_khoannop_viewmodels.map((item) => ({
                    sf_nhomkhoannop_id: item.sf_khoannop_group_id,
                    sf_khoannop_id: item.sf_khoannop_id,
                    so_tien_dinh_muc: item.so_tien_dinh_muc,
                    so_tien_phai_nop: item.so_tien_dinh_muc - (item.so_tien_mien_giam || 0),
                    sf_mucthuphi_id: item.sf_hinhthucmiengiam_id,
                }));
            const mappedIds = tinhBaoPhiKhoanResponses.sf_hinhthucnopboms.map((item) => item.id);
            setHinhThucNopBomIds(mappedIds);
            setKhoanNopChungTus(mappedData);
        }
    }, [tinhBaoPhiKhoanResponses]);
    const handleUpdateKhoanNops = (data: IKhoanNopChungTuVm[], hinhThucNopBomIds: number[]) => {
        setKhoanNopChungTus(data);
        setHinhThucNopBomIds(hinhThucNopBomIds)
        handleSaveBaoPhi(data, hinhThucNopBomIds.join(','));
    };
    const handleTinhMienGiams = (data: boolean) => {
        setIsTinhMienGiam(data);
        setCurrentStepId(currentStepId + 1)

    };
    const handleSaveBaoPhi = async (data: IKhoanNopChungTuVm[], hinhThucNopBomIds: string) => {
        const sf_khoannops: ITinhBaoPhiItemRequest[] = data.map(khoan => ({
            sf_khoannop_id: khoan.sf_khoannop_id,
            sf_mucthuphi_id: khoan.sf_mucthuphi_id,
            so_tien_dinh_muc: khoan.so_tien_dinh_muc,
            so_tien_ap_dung: khoan.so_tien_phai_nop,
        }));
        const sf_tinhbaophi_insert: ITinhBaoPhiInsertModel = {
            nam_hoc: nam_hoc,
            ts_hocsinh_id: hocSinh.id,
            is_calculate_miengiam: isTinhMienGiam,
            sf_khoannops: sf_khoannops,
            sf_hinhthucnopbom_ids: hinhThucNopBomIds,
            sf_tinhbaophi_id: tinhBaoPhiEditing?.id ?? 0,
            sf_hinhthucnopbom_id: 0,
        }
        setIsLoading(true)
        const res = await financeHelperApi.sf_tinhbaophi_insert(sf_tinhbaophi_insert)
        if (res.is_success) {
            set_sf_tinhbaophi_id(res.data.data)
        }
        setCurrentStepId(currentStepId + 1)
        setIsLoading(false)

    }

    const handleReloadDataBaoPhi = async () => {
        setIsLoading(true)
        const res = await financeHelperApi.sf_tinhbaophi_selectbyid(tinhBaoPhiEditing?.id);
        setIsLoading(false)
        if (res.is_success) {
            setTinhBaoPhiKhoanResponses(res.data.data[0]);
        }
    };
    const handleSendEmailBaoPhi = async (data: ISendEmailBaoPhiRequest) => {
        setIsLoading(true)
        const res = await financeHelperApi.sf_tinhbaophi_send_baophi(data)
        setCurrentStepId(currentStepId + 1)
        setIsLoading(false)

    }
    return (
        <Box>
            <Box>
                <BaoPhiSteps steps={steps}
                    currentStepId={currentStepId}
                    onStepChanged={(id) => {
                        setCurrentStepId(id)

                    }}
                />
            </Box>
            <Box sx={{ pt: 1, overflow: 'auto' }}>
                {currentStepId === 1 &&
                    <Box>
                        <HinhThucNopPhi isTinhMienGiam={isTinhMienGiam} hocSinh={hocSinh} onSubmit={(data: any) => { handleTinhMienGiams(data) }} onBack={() => { setCurrentStepId(1) }} onCancel={onCancel} />
                    </Box>
                }
                {currentStepId === 2 &&
                    <Box>
                        <DanhSachKhoanNop khoanNopChungTuCreate={khoanNopChungTus} hinhThucNopBomSelectedIds={hinhThucNopBomIds} hocSinh={hocSinh} onSubmit={(data: any, hinhThucNopBomIds: any) => { handleUpdateKhoanNops(data, hinhThucNopBomIds) }} onBack={() => { setCurrentStepId(currentStepId - 1) }} onCancel={onCancel} isLoading={isLoading} />
                    </Box>
                }
                {/* {currentStepId === 2 &&
                    <Box>
                        <HinhThucMienGiam isTinhMienGiam={isTinhMienGiam} hocSinh={hocSinh} onSubmit={(data: any) => { handleTinhMienGiams(data) }} onBack={() => { setCurrentStepId(currentStepId - 1) }} onCancel={onCancel} isLoading={isLoading} />
                    </Box>
                } */}
                {currentStepId === 3 &&
                    <Box>
                        <KetQuaBaoPhi hinhThucNopBomSelectedIds={hinhThucNopBomIds} hocSinh={hocSinh} onSubmit={() => { setCurrentStepId(currentStepId + 1) }} onBack={() => { setCurrentStepId(currentStepId - 1) }} onCancel={onCancel} sf_tinhbaophi_id={sf_tinhbaophi_id} />
                    </Box>
                }
                {currentStepId === 4 &&
                    <Box>
                        <GuiBaoPhi  hocSinh={hocSinh} onSubmit={(data: ISendEmailBaoPhiRequest) => { handleSendEmailBaoPhi(data) }} onBack={() => { setCurrentStepId(currentStepId - 1) }} onCancel={onCancel} isLoading={isLoading} sf_tinhbaophi_id={sf_tinhbaophi_id} />
                    </Box>
                }
                {/* {currentStepId === 5 &&
                    <Box>
                        <ThankForm hocSinh={hocSinh} onSubmit={() => { setCurrentStepId(currentStepId + 1) }} onBack={() => { setCurrentStepId(currentStepId - 1) }} onCancel={onCancel} sf_tinhbaophi_id={sf_tinhbaophi_id} isLoading={isLoading} />
                    </Box>
                } */}
            </Box>

        </Box>
    );
};

export default BaoPhiCreateLayout;